export const ListWrappers = {} as any

export const renderPanelContent = (key: string | undefined) => {
  let component = <></>
  if (key) {
    component = ListWrappers[key]
  }
  return component
}
